var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItalicSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 20,
    viewBox: "0 0 7 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97242 4.026C4.12623 3.878 3.30959 4.35 3.1416 5.072L0.0306154 18.4053C-0.138156 19.1273 0.407823 19.83 1.25012 19.974C1.35356 19.992 1.45623 20 1.55733 20C2.28375 20 2.93394 19.5613 3.08094 18.928L6.19192 5.59467C6.36069 4.87267 5.81471 4.17 4.97242 4.026ZM5.44451 0C4.5851 0 3.88902 0.596667 3.88902 1.33333C3.88902 2.07 4.5851 2.66667 5.44451 2.66667C6.30392 2.66667 7 2.07 7 1.33333C7 0.596667 6.30392 0 5.44451 0Z",
    fill: "#282860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalicSign);
export default __webpack_public_path__ + "static/media/italic_sign.3f76d1c263f04e74ef326c12cebb6316.svg";
export { ForwardRef as ReactComponent };